import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ElementRef, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreService } from '../../../services/core.service';
import { MatIconModule } from '@angular/material/icon';
import { map, catchError, take } from "rxjs/operators";
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe, NgIf } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeEl from '@angular/common/locales/el';
import { LOCALE_ID } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';


registerLocaleData(localeEl);

@Component({
  selector: 'app-facebook-post',
  imports: [NgIf, CommonModule, MatIconModule],
  providers: [DatePipe, { provide: LOCALE_ID, useValue: 'en' }],
  templateUrl: './facebook-post.component.html',
  styleUrl: './facebook-post.component.scss'
})
export class FacebookPostComponent {
  id: string | null = null;
  companyID: number = 0;
  siteDomain: string = 'dummy.view';
  socialTag: string = '';
  switchboardImage: number = 0;
  mainImageUrl: string = '';
  thumbnailFilePath: string = '';
  postFeed: string = '';
  postTitle: string = '';
  postDescription: string = '';
  totChars: number = 0;
  articleUrl: string = '';
  scheduledFor: Date | null = null;
  formattedDate: string = '';
  textDirection: 'ltr' | 'rtl' = 'ltr';


  private readonly VIDEO_TAGS = new Set([
    'fbvideo',
    'igvideo',
    'igcarousel',
    'fbstoryvideo',
    'igstoryvideo',
    'tiktokstoryvideo',
    'tiktokcarousel',
    'tiktokvideo',
    'fbstoryreel',
    'fbreel',
  ]);

  isVideo: boolean = false;   // used in template
  postStatus: string = '';
  videoUrl: string = '';
  isYouTube: boolean = false;
  youTubeEmbedUrl: SafeResourceUrl | null = null;
  private updatingToastRef: MatSnackBarRef<any> | null = null;



  constructor(
    private http: HttpClient,
    private readonly coreService: CoreService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private datePipe: DatePipe,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private snackBar: MatSnackBar

  ) { }

  ngOnInit() {
    // window.location.reload(); 
    this.companyID = this.coreService.user?.companyID || 0;
    this.id = this.route.snapshot.paramMap.get("id");
    if (this.id) {
      this.loadPost(this.id);
    }
    //this.showUpdatingToast();
  }

  loadPost(id: string): void {
    this.coreService.getData(`/manual-post/editPost/${this.companyID}/${id}`)
      .pipe(take(1))
      .subscribe((res: any) => {
        if (!res) {
          this.coreService.showSnackbar("Post not found.");
          return;
        }
        this.textDirection = (res.text_direction === 'rtl') ? 'rtl' : 'ltr';
        this.postStatus = res.post_status;
        this.socialTag = res.social_tag;
        // TOAST: show while video_url is null/empty (only for video-type tags)
        const statusOk = this.postStatus !== 'Fail Permanently' && this.postStatus !== 'Failed';
        const tag = (this.socialTag || '').trim().toLowerCase();
        const isVideoTag = statusOk && this.VIDEO_TAGS.has(tag);

        const rawVideoUrl = (res.video_url && String(res.video_url).trim()) || '';

        if (isVideoTag && !rawVideoUrl) {
          this.showUpdatingToast();
        } else {
          this.hideUpdatingToast();
        }


        const taggedAsVideo = this.isVideoPost(this.postStatus, this.socialTag);

        const rawVideo =
          (res.createomate_video && String(res.createomate_video).trim()) ||
          (res.video_url && String(res.video_url).trim()) ||
          '';

        const hasVideo = !!rawVideo;

        this.isVideo = taggedAsVideo && hasVideo;

        if (this.isVideo) {
          this.videoUrl = this.toStoragePath(rawVideo);

          if (this.videoUrl && !/^https?:\/\//i.test(this.videoUrl)) {
            this.videoUrl = `${this.backendOrigin()}${this.videoUrl}`;
          }

          this.isYouTube = this.isYouTubeUrl(this.videoUrl);
          this.youTubeEmbedUrl = this.isYouTube
            ? this.sanitizer.bypassSecurityTrustResourceUrl(this.toYouTubeEmbed(this.videoUrl))
            : null;
        } else {
          this.videoUrl = '';
          this.isYouTube = false;
          this.youTubeEmbedUrl = null;
        }

        // Domain
        this.siteDomain = (res.Domain || '').replace('https://www.', '');

        this.switchboardImage = res.switchboard_img != null ? 1 : 0;

        const rssMainImage =
        (res.rss_img_url && String(res.rss_img_url).trim()) || '';

        const arrayFirstImage =
          (Array.isArray(res.image_array) && res.image_array.length > 0)
            ? res.image_array[0]
            : '';

        this.mainImageUrl =
          this.switchboardImage === 1
            ? res.switchboard_img
            : (rssMainImage || arrayFirstImage || './assets/images/na.png');

        this.thumbnailFilePath = res.thumbnail_file_path;
        this.postFeed = res.feed;
        this.postTitle = res.rss_title;

        this.postDescription = res.rss_description || '';
        this.totChars = this.postDescription.length;

        const maxChars = 250;
        this.postDescription =
          this.postDescription.length > maxChars
            ? this.postDescription.substring(0, maxChars) + '...'
            : this.postDescription;

        this.articleUrl = res.article_url;
        // Date
        this.scheduledFor = res.scheduled_for ? new Date(res.scheduled_for) : null;
        this.formattedDate = this.scheduledFor
          ? (this.datePipe.transform(this.scheduledFor, 'd MMMM YYYY') || '')
          : '';

        const element = this.elRef.nativeElement.querySelector('.facebook-card');
        if (element) {
          this.renderer.removeClass(element, 'hidden');
        }
      });
  }

  isVideoPost(status: string | null | undefined, tag: string | null | undefined): boolean {
    const s = (status || '').trim();
    const t = (tag || '').trim().toLowerCase();

    return (
      this.VIDEO_TAGS.has(t) &&
      s !== 'Fail Permanently' &&
      s !== 'Failed'
    );
  }
  private toStoragePath(v: any): string {
    if (!v) return '';
    const s = String(v).trim();
    if (/^https?:\/\//i.test(s)) return s;
    if (s.startsWith('/videos/')) return '/storage' + s;
    if (s.startsWith('videos/')) return '/storage/' + s;
    if (s.startsWith('/storage/')) return s;
    if (s.startsWith('storage/')) return '/' + s;
    return '/storage/' + s.replace(/^\/+/, '');
  }
  private backendOrigin(): string {
    return environment.baseUrl.replace(/\/api\/?$/i, '');
  }

  private isYouTubeUrl(url: string): boolean {
    return /(^https?:\/\/)?(www\.)?(youtube\.com|m\.youtube\.com|youtu\.be)\//i.test(url);
  }

  private toYouTubeEmbed(url: string): string {
    const u = (url || '').trim();

    const embedMatch = u.match(/youtube\.com\/embed\/([^?&/]+)/i);
    if (embedMatch?.[1]) return `https://www.youtube.com/embed/${embedMatch[1]}`;

    const shortsMatch = u.match(/youtube\.com\/shorts\/([^?&/]+)/i);
    if (shortsMatch?.[1]) return `https://www.youtube.com/embed/${shortsMatch[1]}`;

    const vParamMatch = u.match(/[?&]v=([^&]+)/i);
    if (vParamMatch?.[1]) return `https://www.youtube.com/embed/${vParamMatch[1]}`;

    const shortMatch = u.match(/youtu\.be\/([^?&/]+)/i);
    if (shortMatch?.[1]) return `https://www.youtube.com/embed/${shortMatch[1]}`;

    return u;
  }

  private showUpdatingToast(): void {
    if (this.updatingToastRef) return;
    this.updatingToastRef = this.snackBar.open('Updating preview content', undefined, {
      duration:2000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }

  private hideUpdatingToast(): void {
    if (this.updatingToastRef) {
      this.updatingToastRef.dismiss();
      this.updatingToastRef = null;
    }
  }



}